import { IconLogo } from '@components/icons/IconLogo';
import useEditingStore from '@hooks/useEditingStore';
import useLangString from '@hooks/useLangString';
import { $tourData } from '@stores/dataStores';
import { $editingFlag, $editingUIColor } from '@stores/editingStores';
import { TemplateId } from '@types';
import { getTemplateConfig } from '@utils/templateConfig';
import WLogo from '../WLogo';
import useNickname from '../useNickname';

function WUserInfoSimple() {
  const { name, avatar } = useNickname();
  const lang = useLangString({ pv: ['～人来过', '～ views'] }, []);
  const flag = useEditingStore({
    $data: $tourData,
    dataFn: (state) => state.flag,
    $editing: $editingFlag.store,
  });
  const ui = useEditingStore({
    $data: $tourData,
    dataFn: (state) => {
      const ui = state.config?.ui;
      const defaultUI = getTemplateConfig(TemplateId.simple)('uiColor') ?? {};
      if (!ui) return defaultUI;
      return { ...defaultUI, ...ui };
    },
    $editing: $editingUIColor.store,
  });

  const showName = !!(flag?.showAuthorName ?? 1);
  const showPv = !!(flag?.showTourPV ?? 1);

  const renderPV = () => showPv && <div>{lang.pv}</div>;

  return (
    <>
      <div
        className="absolute top-15 left-15"
        style={{ color: `rgba(${ui.fontColor})` }}
      >
        {showName ? (
          <div className="flex h-40 items-center">
            <img
              className="h-35 w-35 rounded-full border border-2 border-white"
              alt=""
              src={avatar}
            />
            <div className="ml-10">
              <div>{name}</div>
              {renderPV()}
            </div>
          </div>
        ) : (
          renderPV()
        )}
      </div>
      <WLogo
        systemIcon={
          <IconLogo
            className="absolute top-15 right-15"
            width={60}
            color={`rgba(${ui.fontColor})`}
          />
        }
      />
    </>
  );
}

export default WUserInfoSimple;
